const getSelectedTemplate = (templatesList, selectedTemplateSlug) =>
  templatesList.find((template) => template.slug === selectedTemplateSlug);

export default getSelectedTemplate;
